"use client";

// src/help-text.tsx
import * as React from "react";
import {
  systemForwardRef,
  useStyleConfig,
  mergeStyles
} from "@stepstone-genesis/system";
import { Text } from "@stepstone-genesis/components-text";
import {
  useFormStateHandlerContext,
  useFormStateHandler
} from "@stepstone-genesis/components-form-state-handler";

// src/styles.ts
import { styles as textStyles } from "@stepstone-genesis/components-text";
var root = {
  color: "colorGreyDark"
};
var sizes = {
  medium: textStyles.variants.small,
  large: textStyles.variants.medium
};
var styles = {
  root,
  sizes
};

// src/help-text.tsx
var FormHelpTextElement = systemForwardRef(
  function FormHelpTextElement2({ context, size = "medium", children, sx, ...props }, ref) {
    const { FORM_HELP_TEXT } = useStyleConfig("FORM_HELP_TEXT", {
      styles: {
        base: styles.root,
        responsiveVariants: [
          {
            id: "help-text-size",
            prop: size,
            variants: styles.sizes
          }
        ]
      }
    });
    return /* @__PURE__ */ React.createElement(
      Text,
      {
        as: "div",
        element: "FORM_HELP_TEXT",
        sx: mergeStyles([FORM_HELP_TEXT.styles, sx]),
        ...props,
        ...context == null ? void 0 : context.formHelpTextProps(props, ref)
      },
      children
    );
  }
);
var FormHelpTextElementNonContext = systemForwardRef(function FormHelpTextElementNonContext2(props, ref) {
  const nonContextFormStateHandler = useFormStateHandler(props);
  return /* @__PURE__ */ React.createElement(
    FormHelpTextElement,
    {
      context: nonContextFormStateHandler,
      ref,
      ...props
    }
  );
});
var FormHelpText = systemForwardRef(
  function FormHelpText2(props, ref) {
    const withinContextFormStateHandler = useFormStateHandlerContext();
    return withinContextFormStateHandler ? /* @__PURE__ */ React.createElement(
      FormHelpTextElement,
      {
        context: withinContextFormStateHandler,
        size: withinContextFormStateHandler.size,
        ref,
        ...props
      }
    ) : /* @__PURE__ */ React.createElement(FormHelpTextElementNonContext, { ref, ...props });
  }
);
export {
  FormHelpText
};
